
export function openLoginWindow (src) {
    // 检测到未登录时，弹出窗口
    const { availHeight, availWidth } = window.screen;
    const width = 700;
    const height = 510;
    const left = (availWidth - width) / 2;
    const top = (availHeight - height) / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},channelmode=0,directories=0,fullscreen=0,` +
      `location=0,menubar=0,resizable=0,scrollbars=0,status=0,titlebar=0,toolbar=0`;
    // 不弹出窗口
    if (!src.show) return;

    const loginUrl = 'https://xui.ptlogin2.qq.com/cgi-bin/xlogin?' +
        'hide_title_bar=1&' +
        'bgcolor=ffffff&' +
        'no_verifyimg=1&' +
        'link_target=blank&' +
        'style=23&' +
        'appid=535053601&' +
        'daid=379&' +
        'target=self&' +
        'enable_qlogin=1&' +
        's_url=https%3A//login.bk.tencent.com/forward/%3Fapp_code%3Dbkos%26bk_login%3D0%26c_url%3D' + src.callback;

    if (src.code !== undefined && src.code === '000') {
        // 注销用户提示
        window.loginWindow = window.open('', '_blank', features);
        document.cookie = 'p_skey=; domain=.bk.tencent.com; path=/; max-age=0';
        document.cookie = 'p_skey=; domain=dev.bk.tencent.com; path=/; max-age=0';
        window.loginWindow.document.write(
            `<html>
                <title>账号未注册提示</title>
                <body style="margin: 0;">
                    <div class="logout-wrap" style="font-size: 14px; text-align: center;">
                        <span style="height: 42px; width: 42px; margin: 125px auto 19px; border-radius: 50%; background: #ffdddd; display: flex; align-items: center; justify-content: center;">
                            <img height="22px" width="22px" src="https://smarttestpublic-10032816.file.myqcloud.com/custom/20220801100521/7670/20220801100521/--42159309e60ac2d4f5a4ca6f185753e2.png" alt="" />
                        </span>
                        <p style="font-size: 20px; color: #313238; line-height: 32px; margin-bottom: 8px;">账号未注册</p>
                        <p style="color: #63656e; line-height: 22px; margin-bottom: 24px;">${src.message}</p>
                        <span onclick="window.location.replace('${loginUrl}')" style="display: inline-block; width: 120px; height: 32px; background: #3a84ff; border-radius: 2px; color: #fff; text-align: center; line-height: 32px; cursor: pointer;">切换账号</span>
                    </div>
                </body>
            </html>`
        );
    }
    else {
        window.loginWindow = window.open(loginUrl, '_blank', features);
    }
}



// WEBPACK FOOTER //
// ./src/js/smart.js